import { NotificationContainer } from "components/NotificationsCenter/components/ClaireNotification/components/NotificationContainer";

import type { NotificationRegistryConfig } from "components/NotificationsCenter/components";

type NewAppointmentNotificationProps = {
  icon: string;
  title: string;
  description?: string;
  closeToast: () => void;
};

export const NewAppointmentNotification = ({ icon, title, description, closeToast }: NewAppointmentNotificationProps) => (
  <NotificationContainer icon={icon} title={title} description={description} onCloseNotification={closeToast} />
);

export const NewAppointmentNotificationConfig: NotificationRegistryConfig = {
  toastOptions: { style: { width: "450px", right: "130px" } },
  render: ({ closeToast, icon, title, description }) => <NewAppointmentNotification icon={icon} title={title} description={description} closeToast={closeToast} />
};
